import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lọc danh sách bảng lương
export function locBangLuong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/bang-luong/phieu-luong/loc/danh-sach', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết bảng lương
export function layChiTietBangLuong(id: number) {
  try {
    return axiosApi.get('/bang-luong/phieu-luong/' + id + '/chi-tiet')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách bảng lương của tôi
export function layBangLuongCuaToi(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/bang-luong/phieu-luong/nhan-vien/' + userId, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy bảng lương theo kỳ
export function layBangLuongTheoKy(userId: number, periodId: number) {
  try {
    return axiosApi.get('/bang-luong/phieu-luong/nhan-vien/' + userId + '/ky-luong/' + periodId)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách bảng lương theo kỳ lương
export function layDanhSachBangLuongTheoKy(periodId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/bang-luong/phieu-luong/ky-luong/' + periodId + '/danh-sach', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tính lương
export function tinhLuong(params: any) {
  try {
    return axiosApi.post('/bang-luong/phieu-luong/tinh-luong', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xác nhận bảng lương
export function xacNhanBangLuong(id: number) {
  try {
    return axiosApi.post('/bang-luong/phieu-luong/' + id + '/xac-nhan')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Khóa bảng lương
export function khoaBangLuong(id: number) {
  try {
    return axiosApi.post('/bang-luong/phieu-luong/' + id + '/khoa')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Gửi bảng lương
export function guiBangLuong(params: any) {
  try {
    return axiosApi.post('/bang-luong/phieu-luong/gui', params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
